import React from "react"
import Form from "../custom/Form"
import { Input, Box, Button, Text, InputGroup, InputRightElement, VStack } from '@chakra-ui/react'
import { UseFormReturnType } from "@mantine/form";
import { PasswordType } from '../admin/ProfileTab'

interface PasswordInputProps {
  value?: string,
  onChange?: () => void,
  props?: any,
  focusBorderColor?: string,
  disabled?: boolean,
  borderColor: string,
  border: string
}

export function PasswordInput({
  value,
  onChange,
  focusBorderColor,
  borderColor,
  props,
  disabled,
  border
}: PasswordInputProps) {
  const [show, setShow] = React.useState(false)
  const handleClick = () => setShow(!show)

  return (
    <InputGroup size='md'>
      <Input
        size='lg'
        p='2' borderRadius='5' color='gray.500'
        fontWeight='semibold'
        border={border}
        _hover={{ outlineColor: 'transparent' }}

        borderColor={borderColor} 
        _focus={{ outlineColor: 'transparent' }} 
        focusBorderColor={focusBorderColor}
        pr='4.5rem' disabled={disabled}
        value={value} onChange={onChange} 
        type={show ? 'text' : 'password'}
        placeholder='**********'
        {...props}
      />
      <InputRightElement width='4.5rem'>
        {!disabled &&
          <Button
            borderColor='#313338'
            colorScheme='gray' mt={2} size='xs'
            fontSize={10} onClick={handleClick}
          >
            {show ? 'Hide' : 'Show'}
          </Button>
        }
      </InputRightElement>
    </InputGroup>
  )
}

interface Props {
  handleChangePassword: (values: PasswordType) => void;
  changePasswordForm: UseFormReturnType<{
    current_password: string,
    new_password: string,
  }>,
  isLoading: {
    changePassword: boolean;
    admins: boolean
  }
}

const ChangePasswordForm: React.FC<Props> = ({
  handleChangePassword,
  changePasswordForm,
  isLoading
}) => {
  return (
    <Form
      style={{ width: '100%' }}
      onSubmit={changePasswordForm.onSubmit((values) => handleChangePassword(values))}
    >
      <VStack spacing='5'>
        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            Current Password
          </Text>

          <Box mt='2'>
            <PasswordInput
              props={{ ...changePasswordForm.getInputProps('current_password') }}
              disabled={isLoading.changePassword}
              border={changePasswordForm.errors.current_password ? '2px' : '1px'}
              borderColor={changePasswordForm.errors.current_password ? 'red.500' : 'gray.500'}
              focusBorderColor={changePasswordForm.errors.current_password ? 'red.500' : 'gray.500'} 
            />

            {changePasswordForm.errors.current_password &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {changePasswordForm.errors.current_password}
              </Text>
            }
          </Box>
        </Box>

        <Box w='100%'>
          <Text fontWeight='semibold' color='gray.500'>
            New Password
          </Text>

          <Box mt='2'>
            <PasswordInput
              props={{ ...changePasswordForm.getInputProps('new_password') }}
              disabled={isLoading.changePassword}
              border={changePasswordForm.errors.new_password ? '2px' : '1px'}
              borderColor={changePasswordForm.errors.new_password ? 'red.500' : 'gray.500'}
              focusBorderColor={changePasswordForm.errors.new_password ? 'red.500' : 'gray.500'} 
            />

            {changePasswordForm.errors.new_password &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {changePasswordForm.errors.new_password}
              </Text>
            }
          </Box>
        </Box>

        {changePasswordForm.isTouched() &&
          <Box mt={5} w="100%">
            <Button
              isLoading={isLoading.changePassword}
              type="submit"
              bg='#37A75B' size="lg"
              w='100%' color='white'
              _hover={{ backgroundColor: isLoading.changePassword ? '#37A75B' : '#046425' }}
            >
              Update
            </Button>
          </Box>
        }
      </VStack>
    </Form>
  )
}

export default ChangePasswordForm